/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericBenefit } from './GenericBenefit';
import {
    GenericBenefitFromJSON,
    GenericBenefitFromJSONTyped,
    GenericBenefitToJSON,
    GenericBenefitToJSONTyped,
} from './GenericBenefit';
import type { ActiveCoverageOtherPayers } from './ActiveCoverageOtherPayers';
import {
    ActiveCoverageOtherPayersFromJSON,
    ActiveCoverageOtherPayersFromJSONTyped,
    ActiveCoverageOtherPayersToJSON,
    ActiveCoverageOtherPayersToJSONTyped,
} from './ActiveCoverageOtherPayers';
import type { SubscriberCoverageInfo } from './SubscriberCoverageInfo';
import {
    SubscriberCoverageInfoFromJSON,
    SubscriberCoverageInfoFromJSONTyped,
    SubscriberCoverageInfoToJSON,
    SubscriberCoverageInfoToJSONTyped,
} from './SubscriberCoverageInfo';

/**
 * 
 * @export
 * @interface ActiveCoverage
 */
export interface ActiveCoverage {
    /**
     * 
     */
    sections: Array<GenericBenefit>;
    /**
     * 
     */
    subscriber_coverage_info?: SubscriberCoverageInfo;
    /**
     * 
     */
    other_payers?: ActiveCoverageOtherPayers;
    /**
     * 
     */
    qmb?: Array<GenericBenefit>;
}

/**
 * Check if a given object implements the ActiveCoverage interface.
 */
export function instanceOfActiveCoverage(value: object): value is ActiveCoverage {
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function ActiveCoverageFromJSON(json: any): ActiveCoverage {
    return ActiveCoverageFromJSONTyped(json, false);
}

export function ActiveCoverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveCoverage {
    if (json == null) {
        return json;
    }
    return {
        
        'sections': ((json['sections'] as Array<any>).map(GenericBenefitFromJSON)),
        'subscriber_coverage_info': json['subscriber_coverage_info'] == null ? undefined : SubscriberCoverageInfoFromJSON(json['subscriber_coverage_info']),
        'other_payers': json['other_payers'] == null ? undefined : ActiveCoverageOtherPayersFromJSON(json['other_payers']),
        'qmb': json['qmb'] == null ? undefined : ((json['qmb'] as Array<any>).map(GenericBenefitFromJSON)),
    };
}

export function ActiveCoverageToJSON(json: any): ActiveCoverage {
    return ActiveCoverageToJSONTyped(json, false);
}

export function ActiveCoverageToJSONTyped(value?: ActiveCoverage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sections': ((value['sections'] as Array<any>).map(GenericBenefitToJSON)),
        'subscriber_coverage_info': SubscriberCoverageInfoToJSON(value['subscriber_coverage_info']),
        'other_payers': ActiveCoverageOtherPayersToJSON(value['other_payers']),
        'qmb': value['qmb'] == null ? undefined : ((value['qmb'] as Array<any>).map(GenericBenefitToJSON)),
    };
}

